import React from "react";

import "../styles/components/SectionHistory.css";

const SectionHistory = ({ data }) => {
  return (
    <div className="section-history container container-small">
      {data.singleElement &&
        data.singleElement.map((item, idx) => {
          const itemNumber = idx + 1 <= 9 ? "0" + (idx + 1) : idx + 1;
          return (
            <div key={idx} className={`single-post row ${idx % 2 ? "right-side" : ""}`}>
              <div className={`single-post--image col-12 col-md-6 ${idx % 2 ? "offset-md-1" : ""}`}>
                <img src={item.photoUrl} alt="" />
              </div>
              <div className={`single-post--desc col-12 col-md-5 ${idx % 2 ? "" : "offset-md-1"}`}>
                <h5>
                  <span>{itemNumber}.</span>
                  {item.titleMain}
                </h5>
                <div>
                  <p className="title">{item.titleSecond}</p>
                  <p className="post-desc">{item.description}</p>
                </div>
              </div>
            </div>
          );
        })}
    </div>
  );
};

export default SectionHistory;
